module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Hiui-PC")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("移动端组件库")])]), _vm._v(" "), _c('h2', [_vm._v("开发环境")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("生产环境（demo）")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v("生产环境（library）")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("使用")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', [_vm._v("全部引入")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h3', [_vm._v("单个组件引入")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("需要安装 stylus-loader / stylus 依赖")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("使用")]), _vm._v(" "), _vm._m(8)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-bash"
  }, [_vm._v("$ npm run dev\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-bash"
  }, [_vm._v("$ npm run build\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-bash"
  }, [_vm._v("$ npm run package\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-bash"
  }, [_vm._v("$ npm install hiui-pc --save\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-js"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" hiuipc "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui-pc'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui-pc/dist/hiuipc.css'")]), _vm._v("\n\nVue.use(hiuipc)\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-html"
  }, [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("Btn")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("size")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"lg\"")]), _vm._v(">")]), _vm._v("Hiui-PC"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("Btn")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _c('span', {
    staticClass: "javascript"
  }, [_vm._v("\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" Btn "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui-pc/src/components/Btn'")]), _vm._v("\n\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n      Btn\n    }\n  }\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("使用 "), _c('code', [_vm._v("webpack")]), _vm._v(" 配置模块别名 "), _c('code', [_vm._v("alias")]), _vm._v(" 单个引入")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-js"
  }, [_c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("module")]), _vm._v(".exports = {\n  "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// ...")]), _vm._v("\n  resolve: {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("alias")]), _vm._v(": {\n      "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui'")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui-pc/src/components'")]), _vm._v("\n    }\n  }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-js"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" Btn "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui/Btn'")]), _vm._v("\n")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ff49a6d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/index-20.vue
// module id = 653
// module chunks = 0